var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopOut = function SvgPopOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.155 6.385c0-.345.28-.624.625-.625h6.062c.301 0 .554.215.612.5l.012.125v6.062a.626.626 0 0 1-1.25 0V7.894l-6.34 6.34a.625.625 0 0 1-.884-.884l6.34-6.34H7.78a.625.625 0 0 1-.625-.626"
  })));
};
export default SvgPopOut;